import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { countTrueValues } from '@citypantry/util';
import { ChoiceItemGroup, SingleItem } from '@citypantry/util-models';

@Component({
  selector: 'app-choice-group',
  templateUrl: './choice-group.component.html',
})
export class ChoiceGroupComponent {

  @Input()
  public itemGroup: ChoiceItemGroup;

  @Input()
  public formGroup: FormGroup;

  @Input()
  public showErrors: boolean;

  public moreInfoItem: SingleItem;

  constructor() {
    this.moreInfoItem = null;
  }

  public isChoiceLimitReached(): boolean {
    return countTrueValues(this.formGroup.value) >= this.itemGroup.maximumOrderQuantity;
  }

  public toggleMoreInfo(item?: SingleItem): void {
    if (!item || this.moreInfoItem === item) {
      this.moreInfoItem = null;
    } else {
      this.moreInfoItem = item;
    }
  }

  public getItemOrder(index: number): number {
    if (index % 2) { // isOdd
      return index * 2 - 1; // Odd items are shifted back one to allow the "more info" panel to take their place
    } else {
      return index * 2;
    }
  }

  public getMoreInfoOrder(index: number): number {
    if (index % 2) { // isOdd
      return index * 2 + 1;
    } else {
      return index * 2 + 2; // Swaps into place for the item at (index + 1) * 2
    }
  }
}
